import { i as a } from "../isFunction-Dv8pj5Ka.js";
function s(r, t, n = "children", i = 0, e = null) {
  const c = t(r, i, e);
  if (c) return c;
  const f = a(n) ? n(r) : n in r ? Array.from(r[n]) : [];
  if (f.length)
    for (const l of f) {
      const u = s(l, t, n, i + 1, r);
      if (u) return u;
    }
}
function m(r, t, n = "children", i = 0, e = null) {
  const c = t(r, i, e);
  if (c) return c;
  const f = a(n) ? n(r) : n in r ? Array.from(r[n]) : [];
  if (f.length)
    for (let l = f.length - 1; l >= 0; l--) {
      const u = f[l], o = m(u, t, n, i + 1, r);
      if (o) return o;
    }
}
function h(r, t, { parent: n, newParent: i } = {}) {
  const e = t(r, { parent: n, newParent: i });
  return e && (r.children && (e.children = r.children.map((c) => h(c, t, {
    parent: r,
    newParent: e
  })).filter((c) => !!c)), e);
}
function v(r, t) {
  for (const n of r) {
    const i = s(n, t);
    if (i) return i;
  }
}
function y(r, t) {
  return r.map((n) => h(n, t)).filter((n) => !!n);
}
function g(r) {
  let t = 0;
  return s(r, () => {
    t++;
  }), t;
}
function A(r, t, n = "itemId") {
  return s(r, (i) => i[n] === t && i);
}
function w(r, t = "") {
  t = t.split(".");
  let n = r;
  for (const i of t)
    n = n.children[parseInt(i, 10)];
  return n;
}
export {
  g as countNodes,
  A as findNode,
  w as getChildByPath,
  s as traverse,
  v as traverseArray,
  m as traverseBackwards,
  h as treemap,
  y as treemapArray
};
